import React, { Component } from "react";
import { NavLink } from "react-router-dom";

/**
 * Main Navigation component with routing links and search functionality
 * Provides navigation between different family member pages
 */
export default class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: ''
    };
  }

  /**
   * Handles search input changes
   */
  handleSearchChange = (event) => {
    this.setState({ searchTerm: event.target.value });
  }

  /**
   * Handles search form submission
   */
  handleSearchSubmit = (event) => {
    event.preventDefault();
    // TODO: Implement search functionality
    console.log('Search term:', this.state.searchTerm);
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <NavLink
                  to="/parent"
                  className="nav-link"
                  activeClassName="active"
                  aria-label="Navigate to Parent's page"
                >
                  <i className="fas fa-user-tie mr-2 text-primary"></i>
                  <span>Parent</span>
                  <small className="d-block">Adult</small>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/childa"
                  className="nav-link"
                  activeClassName="active"
                  aria-label="Navigate to ChildA's page"
                >
                  <i className="fas fa-baby mr-2 text-primary"></i>
                  <span>ChildA</span>
                  <small className="d-block">Infant</small>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/childb"
                  className="nav-link"
                  activeClassName="active"
                  aria-label="Navigate to ChildB's page"
                >
                  <i className="fas fa-child mr-2 text-success"></i>
                  <span>ChildB</span>
                  <small className="d-block">Kid</small>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/dev-status"
                  className="nav-link"
                  activeClassName="active"
                  aria-label="Navigate to Dev Status page"
                >
                  <i className="fas fa-code-branch mr-2 text-primary"></i>
                  <span>Dev Status</span>
                  <small className="d-block">Progress</small>
                </NavLink>
              </li>
            </ul>

            <div className="navbar-text mr-3">
              <small>
                <i className="fas fa-users mr-1"></i>
                Family Members: 3
              </small>
            </div>
          </div>

          <form
            className="form-inline my-2 my-lg-0"
            onSubmit={this.handleSearchSubmit}
          >
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text bg-white border-right-0">
                  <i className="fas fa-search"></i>
                </span>
              </div>
              <input
                id="search-input"
                className="form-control border-left-0"
                type="search"
                placeholder="Search members..."
                aria-label="Search family members"
                value={this.state.searchTerm}
                onChange={this.handleSearchChange}
                style={{ borderLeft: 'none' }}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-outline-primary"
                  type="submit"
                  aria-label="Submit search"
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </nav>
    );
  }
}